import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isSaving: false,
  isDeleting: false,

  result: [],
};

const eligibilityMCPReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.SAVE_MCP_TASK_REQUEST:
      return {
        ...state,
        result: [],
        isSaving: true,
      };

    case types.SAVE_MCP_TASK_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSaving: false,
      };

    case types.SAVE_MCP_TASK_FAILURE:
      return {
        ...state,
        result: [],
        isSaving: false,
      };

    case types.DELETE_MCP_TASK_REQUEST:
      return {
        ...state,
        result: [],
        isDeleting: true,
      };

    case types.DELETE_MCP_TASK_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDeleting: false,
      };

    case types.DELETE_MCP_TASK_FAILURE:
      return {
        ...state,
        result: [],
        isDeleting: false,
      };

    default:
      return state;
  }
};

export default eligibilityMCPReducer;
